import React from 'react'
import clsx from 'clsx'
import { TextField as MUITextField, FormControl } from '@material-ui/core'
import useStyles from './FormFieldsStyle'

export default function TextField({
  field,
  values,
  setValues,
  onChange,
  errors,
}) {
  const classes = useStyles()

  return (
    <FormControl
      fullWidth
      className={clsx(
        classes.withMargin,
        field.withRightMargin && classes.withRightMargin
      )}
      variant="outlined"
    >
      <div className={classes.inputLabel} shrink>
        {field.label}
      </div>
      <MUITextField
        className={clsx(classes.customBorder, classes.inputFont)}
        variant="outlined"
        name={field.key}
        type={field.fieldType}
        onChange={
          onChange
            ? onChange
            : (event) => {
                if (errors) {
                  delete errors[field.key]
                }
                const onlyNumbers = /^[0-9\b]+$/
                const onlyLetters = /^[A-Za-zñÑáéíóúÁÉÍÓÚ\s]+$/
                let isValidInput = true
                if (field.numeric) {
                  isValidInput = onlyNumbers.test(event.target.value)
                }
                if (field.onlyLetters) {
                  isValidInput = onlyLetters.test(event.target.value)
                }
                if (isValidInput || event.target.value === '') {
                  let value = event.target.value
                  if (field.allCaps) {
                    value = value.toUpperCase()
                  }
                  setValues({ ...values, [field.key]: value })
                }
              }
        }
        value={values && values[field.key]}
        error={errors && !!errors[field.key]}
        helperText={errors && errors[field.key]}
        fullWidth
        disabled={field.disabled}
        size="small"
        inputProps={{
          className: field.capitalized ? classes.inputTransform : '',
        }}
        InputProps={{
          placeholder: field.hint,
          ...(field.numeric && {
            inputMode: 'numeric',
            pattern: '[0-9]*',
          }),
        }}
      />
    </FormControl>
  )
}
